import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import settingDrawer from './ko-KR/settingDrawer';
export default _objectSpread({}, settingDrawer);